import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function TransactionsIcon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 512.011 512.011">
            <path d="M505.755,240.923l-85.333-85.333c-6.101-6.101-15.253-7.915-23.253-4.629c-7.979,3.307-13.163,11.093-13.163,19.712
	v21.333h-64c-11.797,0-21.333,9.557-21.333,21.333v85.333c0,11.776,9.536,21.333,21.333,21.333h64v21.333
	c0,8.619,5.184,16.405,13.163,19.712c2.645,1.088,5.419,1.621,8.171,1.621c5.547,0,11.008-2.176,15.083-6.251l85.333-85.333
	C514.096,262.747,514.096,249.264,505.755,240.923z"/>
            <path d="M192.005,192.005h-64v-21.333c0-8.619-5.184-16.405-13.163-19.712c-8-3.307-17.152-1.472-23.253,4.629L6.256,240.923
	c-8.341,8.341-8.341,21.824,0,30.165l85.333,85.333c4.075,4.075,9.536,6.251,15.083,6.251c2.752,0,5.525-0.533,8.171-1.621
	c7.979-3.307,13.163-11.093,13.163-19.712v-21.333h64c11.797,0,21.333-9.557,21.333-21.333v-85.333
	C213.339,201.563,203.803,192.005,192.005,192.005z"/>
            <path d="M256.005,85.339c-11.797,0-21.333,9.557-21.333,21.333v298.667c0,11.776,9.536,21.333,21.333,21.333
	s21.333-9.557,21.333-21.333V106.672C277.339,94.896,267.803,85.339,256.005,85.339z"/>
        </SvgIcon>
    );
}



// WEBPACK FOOTER //
// ./views/home/supervisor-home/expenditure-by-organization/assets/transactions-icon.js